import { T, always, cond, test } from 'ramda';

export const OCTET_STREAM_MIME_TYPE = 'application/octet-stream';
export const PDF_MIME_TYPE = 'application/pdf';
export const CSS_MIME_TYPE = 'text/css';
export const JS_MIME_TYPE = 'text/javascript';

const pdfSuffix = /\.pdf$/i;
const gifSuffix = /\.gif$/i;
const jpgSuffix = /\.jpe?g$/i;
const pngSuffix = /\.png$/i;
const bmpSuffix = /\.bmp$/i;

export const getMimeTypeForFileName = cond([
    [test(pdfSuffix), always(PDF_MIME_TYPE)],
    [test(gifSuffix), always('image/gif')],
    [test(jpgSuffix), always('image/jpeg')],
    [test(pngSuffix), always('image/png')],
    [test(bmpSuffix), always('image/bmp')],
    [T, always(OCTET_STREAM_MIME_TYPE)],
]);
